import styled from 'styled-components';
import { palette } from '../../../palette';
import { createShouldForwardProp } from '../../utils';
export const CircleRoot = styled.svg.withConfig({
  componentId: "ds__sc-1o5cbk7-0"
})(["display:inline-block;flex-shrink:0;transform:rotate(-90deg);width:100%;transform-origin:center;fill:none;"]);
export const CircleBar = styled.circle.attrs(() => ({
  cx: 34,
  cy: 34,
  r: 32
})).withConfig({
  componentId: "ds__sc-1o5cbk7-1"
})(["fill:none;stroke-width:3px;stroke:", ";stroke-dashoffset:100;transition:stroke-dashofsset 1s ease;"], _ref => {
  let {
    theme
  } = _ref;
  return theme.Progress.background;
});
export const CircleFill = styled.circle.withConfig({
  shouldForwardProp: createShouldForwardProp(['color', 'value'])
}).attrs(() => ({
  cx: 34,
  cy: 34,
  r: 32
})).withConfig({
  componentId: "ds__sc-1o5cbk7-2"
})(["stroke:", ";stroke-dashoffset:", ";stroke-dasharray:300;stroke-width:3px;transition:stroke-dashoffset 1s ease-in-out;"], _ref2 => {
  let {
    theme,
    color
  } = _ref2;
  return theme.Progress.PROGRESS_COLOR_TO_COLOR[color] || palette[color];
}, _ref3 => {
  let {
    value
  } = _ref3;
  return 300 - value * 200;
});